<template>
  <generic-modal :modal-key="'confirm_purchase_for_pin_error'" :has-extra-modal-class="'store_popup_box purchase purchase_failed modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
        <h1>{{ getTranslations.home_modals_confirm_purchase_for_pin_title }}<br>
          {{ getTranslations.home_modals_confirm_purchase_for_pin_oups_something }}</h1>
        <img src="static/images/profile/profile-emptystate.png" class="op_down_img">
        <p>{{ getTranslations.home_modals_confirm_purchase_for_pin_bundles_are_currently }}</p>
    </template>
  </generic-modal>
</template>

<script>
// modal_operator_down_PIN
import { mapGetters } from 'vuex';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'confirm-purchase-for-pin-error',
  components: { GenericModal },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseForPinError.vue